import { fuzzySearch } from "@dashboard/misc";
import { Box, Text } from "@saleor/macaw-ui-next";
import type * as React from "react";

import { useActionTriggers } from "./useActionTriggers";

interface ActionsProps {
  query: string;
  onActionClick: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const Actions = ({ query, onActionClick }: ActionsProps) => {
  const triggers = useActionTriggers();
  const searchResults = fuzzySearch(triggers, query, ["name"]);

  const groupedBySection = Object.groupBy(searchResults, result => result.section) as Record<
    string,
    {
      Component: React.ComponentType<{
        onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
      }>;
    }[]
  >;

  return (
    <Box>
      {Object.entries(groupedBySection).map(([section, actions]) => (
        <Box key={section} paddingY={1}>
          <Text fontWeight="medium" size={2} color="default2" paddingX={6}>
            {section}
          </Text>
          {actions.map(({ Component }, index) => (
            <Component key={index} onClick={onActionClick} />
          ))}
        </Box>
      ))}
    </Box>
  );
};
